<script setup lang="ts">
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from 'radix-vue'
import { defineModel, computed } from '#imports'

interface Props {
  max?: number
  step?: number
  min?: number
  range?: boolean
  name?: string
  minStepBetweenThumbs?: number
}

defineProps<Props>()

const modelValue = defineModel<number | number[]>({ required: true })

// Radix slider only accept array
// In order to make the component work with simple number, we use this intermediate computed to normalize to an Array.
const normalizedValue = computed({
  get() {
    return Array.isArray(modelValue.value) ? modelValue.value.slice() : [modelValue.value]
  },
  set(value) {
    if (Array.isArray(modelValue.value)) {
      modelValue.value = value.slice()
    }
    else {
      modelValue.value = value[0]
    }
  },
})
</script>

<template>
  <SliderRoot
    v-model="normalizedValue"
    :max="max"
    :min="min"
    :step="step"
    :name="name"
    :min-step-between-thumbs="minStepBetweenThumbs"
    class="relative flex items-center select-none touch-none h-6"
  >
    <SliderTrack class="bg-gray-200 relative grow rounded-full h-2">
      <SliderRange class="absolute bg-gray-900 rounded-full h-full" />
    </SliderTrack>
    <SliderThumb
      class="block w-5 h-5 bg-white rounded-full border-4 border-gray-900 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-peacock-200/50 focus-visible:ring-offset-2"
    />
    <SliderThumb
      v-if="Array.isArray(modelValue) && modelValue.length > 1"
      class="block w-5 h-5 bg-white rounded-full border-4 border-gray-900 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-peacock-200/50 focus-visible:ring-offset-2"
      aria-label="Volume"
    />
  </SliderRoot>
</template>
